/**
 * O `proxy_path` do processo pode ter mais de uma procuração, separadas
 * por vírgula (transcrição com os dois noivos, homologação preenchida
 * duas vezes). Devolve um link por procuração, com o rótulo do botão.
 */
export function linksDaProcuracao(proxyPath) {
  const links = String(proxyPath || '').split(',').map((l) => l.trim()).filter(Boolean);
  return links.map((href, i) => ({ href, rotulo: links.length > 1 ? `Baixar procuração ${i + 1}` : 'Baixar procuração' }));
}
